import styled from 'styled-components';

import { Card } from 'core/ui/atoms';

const OperationCard = styled(Card)`
  padding: 23px;
`;

export default OperationCard;
